/**
 * Validates an email address using RFC-compliant regex pattern.
 * Checks for proper format: localpart@domain.tld
 * 
 * @param {string} mail - The email address to validate
 * @returns {boolean} True if email is valid, false otherwise
 * 
 * @example
 * validateEmail('user@example.com') // returns true
 * validateEmail('invalid-email') // returns false
 * validateEmail('') // returns false
 */
export default function validateEmail(mail: string): boolean {
  if (mail) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      mail
    );
  }
  return false;
}
